import { OrderAcquisitionType, RecurrenceType } from "@api/graphql/generated/generated-types";

export interface ShipmentFiltersSnapshot {
  debouncedSearchTerm: string;
  trackingNumbersFilter: string;
  displayIdsFilter: number | undefined;
  orderNameSearch: string | undefined;
  selectedDriverLabelIds: string[];
  selectedOrderLabelIds: string[];
  selectedEndCustomerLabelIds: string[];
  selectedCourierBrandIds: string[];
  selectedAcquisitionTypes: OrderAcquisitionType[];
  selectedRecurrenceTypes: RecurrenceType[];
  selectedPickupZoneIds: string[];
  selectedDropoffZoneIds: string[];
  selectedPackageTypeIds: string[];
  selectedOrderVehicleTypeIds: string[];
  selectedDriverVehicleTypeIds: string[];
  selectedServiceTypeIds: string[];
  minWeightInPounds: number | undefined;
  maxWeightInPounds: number | undefined;
  selectedRouteTemplateIds: string[];
  hasOrderInternalNote: boolean;
  hasDriverNoteOnly: boolean;
  hasWaitTimeOrOverride: boolean;
  hasMultipleDriverPayOnly: boolean;
  hasUnapprovedDriverPackageReportOnly: boolean;
  isLate: boolean;
  isOnTime: boolean;
  isAttempted: boolean;
}

export interface ShipmentFilterVariables {
  simpleSearch: string | null;
  trackingNumbersFilter: string | undefined;
  displayIdsFilter: number | undefined;
  orderNameSearch: string | undefined;
  driverLabelIds: string[] | undefined;
  orderLabelIds: string[] | undefined;
  endCustomerLabelIds: string[] | undefined;
  courierBrandIds: string[] | undefined;
  acquisitionTypes: OrderAcquisitionType[] | undefined;
  recurrenceTypes: RecurrenceType[] | undefined;
  pickupZoneIds: string[] | undefined;
  dropOffZoneIds: string[] | undefined;
  packageTypeIds: string[] | undefined;
  orderVehicleTypeIds: string[] | undefined;
  driverVehicleTypeIds: string[] | undefined;
  serviceTypeIds: string[] | undefined;
  minWeightInPounds: number | undefined;
  maxWeightInPounds: number | undefined;
  routeTemplateIds: string[] | undefined;
  hasOrderInternalNote?: boolean;
  hasDriverNoteOnly?: boolean;
  hasWaitTimeOrOverride?: boolean;
  hasMultipleDriverPayOnly?: boolean;
  hasUnapprovedDriverPackageReportOnly?: boolean;
  isDeliveredOnTime?: boolean;
  isAttempted?: boolean;
}

export function makeShipmentFilterVariables(
  filters: ShipmentFiltersSnapshot,
  opts: { isSalesReport: boolean }
): ShipmentFilterVariables {
  const base = {
    simpleSearch: filters.debouncedSearchTerm.length > 0 ? filters.debouncedSearchTerm : null,
    trackingNumbersFilter: filters.trackingNumbersFilter ? filters.trackingNumbersFilter : undefined,
    displayIdsFilter: filters.displayIdsFilter ? filters.displayIdsFilter : undefined,
    orderNameSearch: filters.orderNameSearch ? filters.orderNameSearch : undefined,
    driverLabelIds: filters.selectedDriverLabelIds.length > 0 ? filters.selectedDriverLabelIds : undefined,
    orderLabelIds: filters.selectedOrderLabelIds.length > 0 ? filters.selectedOrderLabelIds : undefined,
    endCustomerLabelIds:
      filters.selectedEndCustomerLabelIds.length > 0 ? filters.selectedEndCustomerLabelIds : undefined,
    courierBrandIds:
      filters.selectedCourierBrandIds.length > 0 ? filters.selectedCourierBrandIds : undefined,
    acquisitionTypes:
      filters.selectedAcquisitionTypes.length > 0 ? filters.selectedAcquisitionTypes : undefined,
    recurrenceTypes:
      filters.selectedRecurrenceTypes.length > 0 ? filters.selectedRecurrenceTypes : undefined,
    pickupZoneIds: filters.selectedPickupZoneIds.length > 0 ? filters.selectedPickupZoneIds : undefined,
    dropOffZoneIds:
      filters.selectedDropoffZoneIds.length > 0 ? filters.selectedDropoffZoneIds : undefined,
    packageTypeIds:
      filters.selectedPackageTypeIds.length > 0 ? filters.selectedPackageTypeIds : undefined,
    orderVehicleTypeIds:
      filters.selectedOrderVehicleTypeIds.length > 0 ? filters.selectedOrderVehicleTypeIds : undefined,
    driverVehicleTypeIds:
      filters.selectedDriverVehicleTypeIds.length > 0 ? filters.selectedDriverVehicleTypeIds : undefined,
    serviceTypeIds:
      filters.selectedServiceTypeIds.length > 0 ? filters.selectedServiceTypeIds : undefined,
    minWeightInPounds: filters.minWeightInPounds ?? undefined,
    maxWeightInPounds: filters.maxWeightInPounds ?? undefined,
    routeTemplateIds:
      filters.selectedRouteTemplateIds.length > 0 ? filters.selectedRouteTemplateIds : undefined,
    ...(filters.isAttempted ? { isAttempted: true as const } : {}),
  };

  if (!opts.isSalesReport) return base;

  return {
    ...base,
    hasOrderInternalNote: filters.hasOrderInternalNote ? true : undefined,
    hasDriverNoteOnly: filters.hasDriverNoteOnly ? true : undefined,
    hasWaitTimeOrOverride: filters.hasWaitTimeOrOverride ? true : undefined,
    hasMultipleDriverPayOnly: filters.hasMultipleDriverPayOnly ? true : undefined,
    hasUnapprovedDriverPackageReportOnly: filters.hasUnapprovedDriverPackageReportOnly ? true : undefined,
    isDeliveredOnTime: filters.isOnTime ? true : filters.isLate ? false : undefined,
  };
}
